import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$http = axios

function corsProxy (http, proxy) {
  if (proxy && proxy !== '') {
    const $request = (config) => {
      if (config.baseURL) {
        config.baseURL = `${proxy}/${config.baseURL}`
      } else if (config.url) {
        config.url = `${proxy}/${config.url}`
      }
      return config
    }
    http.interceptors.request.use($request)
  }
  return http
}

export default axios
export { corsProxy }
